import { Component, EventEmitter, Input, OnChanges, OnInit, Output } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AppSettings } from 'app/modules/shared/app.settings';
import { CommonBindingDataService } from 'app/modules/shared/services/common-binding-data.service';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { UiService } from 'app/modules/shared/services/ui.service';
import * as moment from 'moment';
import { ManageOpenShiftsService } from '../../services/manage-open-shifts.service';

@Component({
  selector: 'app-publish-open-shift',
  templateUrl: './publish-open-shift.component.html',
  styleUrls: ['./publish-open-shift.component.scss']
})
export class PublishOpenShiftComponent implements OnInit, OnChanges {
  @Output() publishOpenShiftEmitter: EventEmitter<any> = new EventEmitter<any>();
  @Input() selectedTeam = '';
  @Input() selectedDate = '';
  isIndividual = true;
  publishOpenShift: any;
  selectedTeamDate: any;
  addeddMembers: any[];
  providerTeamMembersList: any[] = [];
  dateFormat: any;
  minDate: Date;
  maxDate: Date;
  expiryDateRange: string;
  issueDateRange: string;
  ConfirmMaxDateLimit: any;
  startTimeSelected: any;
  startTimeMillisValue: string;
  startEndTimeAMPMFlag: any;
  endTimeSelected: any;
  endTimeMillisValue: string;
  endTime: any;
  endTimeErrorFlag: boolean;
  assignedMembers: any[] = [];
  tenantId: any;
  userInfo: any;
  displaySaveButton: boolean;
  teamList: any[] = [];
  providerIds: any;
  loginUserId: any;
  providerId: any;
  teamId: any = '';
  startDateTimeStr: string;
  endDateTimeStr: string;
  timezoneName = '';
  timezoneAbbr = '';
  // isShiftApplicable: boolean = false;
  minuteArray: number[] = [0, 15, 30, 45];
  currentDate = new Date();
  availableStartTime: Date;
  availableEndTime: Date;
  globalConfigMSFWPU = false;
  organizationLevelDispatch = false;
  globalConfigOS = false;
  showTeamRadioButton = true;

constructor(
  private formBuilder: FormBuilder,
  private commonService: CommonBindingDataService,
  private uiService: UiService,
  private storageService: StorageService,
  private manageOpenShiftsService: ManageOpenShiftsService,
  private commonBindingDataService: CommonBindingDataService,
) {
  this.publishOpenShift = this.formBuilder.group({
    team: ['', [
      Validators.required,
    ]],
    applications: ['1', [
      Validators.required,
      Validators.minLength(1),
      Validators.maxLength(1),
      Validators.pattern(AppSettings.NUMBER_PATTERN)
    ]],
    teamMembers: ['', [
      // Validators.required,
    ]],
    shiftDate: ['', [
      Validators.required,
    ]],
    startTime: ['', [Validators.required]],
    endTime: ['', [Validators.required]],
    notes: ['', []],
    isIndividual: ['true', []]
  });
}

ngOnInit(): void {
  // this.isShiftApplicable = this.storageService.getItem(AppSettings.SHIFT_APPLICABLE);
  this.dateFormat = this.commonService.getDateFormat();
  this.minDate = new Date();
  this.maxDate = new Date();
  this.userInfo = this.storageService.getItem(AppSettings.USER_DETAILS);
  this.tenantId = this.userInfo.tenantId;
  if (this.userInfo) {
    this.loginUserId = this.userInfo.id;
  }
  this.applyProviderRoleScope();
  this.getTeam();
  const futureMaxDateLimit = this.commonService.getTenantConfigValue(AppSettings.EDIT_TEAM_LIST_MAX_DATE);
  this.ConfirmMaxDateLimit = this.commonService.getTenantConfigValue(AppSettings.CONFIRM_MAX_DAYS_ALLOWED_TEAM);
  this.timezoneAbbr = this.commonService.getTenantConfigValue(AppSettings.TIMEZONE_ABBR);
  this.timezoneName = this.commonService.getTenantConfigValue(AppSettings.TIMEZONE_NAME);
  this.maxDate.setDate(this.maxDate.getDate() + parseInt(futureMaxDateLimit, 10));
  this.minDate.setDate(this.minDate.getDate() + 1);
  if (!this.selectedDate) {
    this.publishOpenShift.controls.shiftDate.setValue(this.minDate);
  } else {
    this.publishOpenShift?.controls.shiftDate.setValue(this.selectedDate);
  }
  this.selectedTeamDate = moment(this.publishOpenShift.controls.shiftDate.value).format('MM/DD/YYYY');
  this.currentDate = this.commonBindingDataService.addOneHourToCurrentTime();
  this.globalConfigMSFWPU = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.MANAGE_SHIFT)?.value;
  this.organizationLevelDispatch = this.commonService.getGlobalConfigByKey(AppSettings.DISPATCH_LEVEL_DUTY_ON_OFF)?.value;
  this.globalConfigOS = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.OPEN_SHIFT)?.value;
  if (this.organizationLevelDispatch && this.globalConfigOS && this.globalConfigMSFWPU) {
    this.publishOpenShift.get('isIndividual').setValue('false');
    this.isIndividualNo(false);
    this.showTeamRadioButton = false;
  } else if (this.globalConfigOS) {
    this.showTeamRadioButton = true;
  }
}

ngOnChanges() {
  this.teamId = this.selectedTeam;
  this.selectedTeamDate = this.selectedDate;
  this.publishOpenShift?.controls.team.setValue(this.selectedTeam);
  this.publishOpenShift?.controls.shiftDate.setValue(this.selectedDate);
  this.changeTeamListDate();
}

isIndividualYes(event) {
  this.isIndividual = event;

}

isIndividualNo(event) {
  this.isIndividual = event;
}

onClickPubilstShift() {
  this.assignedMembers = [];
  if (this.isIndividual) {
    const selectedValues = this.publishOpenShift.controls.teamMembers.value;
    selectedValues.forEach(ele => {
      const userId: any = {
        userId: ele
      };
      this.assignedMembers.push(userId);
    });
  }

  if (this.publishOpenShift.controls.startTime.value) {
    this.startDateTimeStr = this.selectedTeamDate + ' ' + moment(this.publishOpenShift.controls.startTime.value).format('hh:mm A');
  }
  if (this.publishOpenShift.controls.endTime.value) {
    this.endDateTimeStr = this.selectedTeamDate + ' ' + moment(this.publishOpenShift.controls.endTime.value).format('hh:mm A');
  }
  const startDate = new Date(this.startDateTimeStr);
  const endDate = new Date(this.endDateTimeStr);

  // Check if the end date is less than the start date
  // if (endDate < startDate) {
  //   // Add one day to the end date
  //   endDate.setDate(endDate.getDate() + 1);
  // }

  if (startDate >= endDate) {
    this.publishOpenShift.controls.endTime.setValue(null);
    this.uiService.showMessage('End time should be greater than Start time', AppSettings.MESSAGE_TYPES.ERROR);
  } else {
  // Format the end date as a string
  const formattedEndDateTimeStr = moment(endDate).format('MM/DD/YYYY hh:mm A');
  const data = {
    teamId: this.teamId,
    applicationType: this.isIndividual ? '10' : '20',
    applicationCount: this.publishOpenShift.controls.applications.value,
    startDateTimeStr: this.startDateTimeStr,
    endDateTimeStr: formattedEndDateTimeStr,
    timezoneName: this.timezoneName,
    timezoneAbbr: this.timezoneAbbr,
    notes: this.publishOpenShift.controls.notes.value,
    openShiftMembers: this.assignedMembers,
  };
  if (!this.isIndividual) {
    delete data.teamId;
    delete data.openShiftMembers;
  }
  this.publishOpenShiftData(data);
}
}

publishOpenShiftData(data) {
  this.displaySaveButton = true;
  this.manageOpenShiftsService.publishOpenshift(JSON.stringify(data)).subscribe(results => {
    // this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPES.SUCCESS);
    this.publishOpenShift.reset();
    this.teamId = '';
    this.publishOpenShift.controls.isIndividual.setValue('true');
    this.publishOpenShift.controls.applications.setValue('1');
    this.publishOpenShift.controls.shiftDate.setValue(this.minDate);
    this.publishOpenShiftEmitter.emit(results);
    this.displaySaveButton = false;
    this.manageOpenShiftsService.setValue(true);
    this.isIndividual = true;
  }, (error) => {
    this.displaySaveButton = false;
    this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPES.ERROR);
  });
}

cancelUserForm() {
  this.publishOpenShift.reset();
  this.teamId = '';
  this.publishOpenShift.controls.isIndividual.setValue('true');
  this.publishOpenShift.controls.applications.setValue('1');
  this.publishOpenShift.controls.shiftDate.setValue(this.minDate);
  this.publishOpenShiftEmitter.emit(null);
  // this.userModel = null;
}

changeTeamListDate(r?) {
  this.providerTeamMembersList = [];
  this.selectedTeamDate = moment(this.publishOpenShift.controls.shiftDate.value).format('MM/DD/YYYY');
  if (this.teamId) {
    this.manageOpenShiftsService.getMemberListWithDateDetails(this.teamId, this.selectedTeamDate).subscribe(results => {
      if (results.length !== 0) {
        results.forEach((obj, i) => {
          let time: any = '';
          obj.userSchedules.forEach((ele, index) => {
            if (ele.slotTimeStr) {
              time = time.concat(ele.slotTimeStr.replace('to', '-') + (index !== obj.userSchedules.length - 1 ? ', ' : ''));
            }
          });
          this.providerTeamMembersList.push({ label: obj.name + (time !== '' ? (': ' + time) : ': Not Available'), value: obj.id });
        });

        this.providerTeamMembersList.sort((a, b) => a.label.localeCompare(b.label));
      }
    }, (error: any) => {
    });
  }
  this.publishOpenShift.controls.teamMembers.setValue([]);
}

doValidSave() {
  if (!this.isIndividual) {
    this.publishOpenShift.get('team').clearValidators();
    this.publishOpenShift.get('team').updateValueAndValidity();
  } else {
    this.publishOpenShift.get('team').setValidators([Validators.required]);
    this.publishOpenShift.get('team').updateValueAndValidity();
  }
  if (this.publishOpenShift.valid) {
    return false;
  } else {
    return true;
  }
}

setStartTimeMillis() {
  const d = new Date(this.publishOpenShift.controls.fromDate.value);
  const dateValue = moment(d).format('MM/DD/YYYY');
  let t;
  if (this.startTimeSelected) {
    t = new Date(this.publishOpenShift.controls.startTime.value);
  } else {
    t = new Date(dateValue + ' ' + this.publishOpenShift.controls.startTime.value);
  }
  const startTimeValue = moment(t).format('hh:mm a');
  this.startTimeMillisValue = dateValue + ' ' + startTimeValue;

  let e;
  const endDateObj = new Date(this.publishOpenShift.controls.fromDate.value);
  if (!this.startEndTimeAMPMFlag) {
    endDateObj.setDate(endDateObj.getDate() + 1);
  }
  const endDateValue = moment(endDateObj).format('MM/DD/YYYY');

  if (this.endTimeSelected) {
    e = new Date(this.publishOpenShift.controls.endTime.value);
  } else {
    e = new Date(endDateValue + ' ' + this.publishOpenShift.controls.endTime.value);
  }
  const endTimeValue = moment(e).format('hh:mm a');
  this.endTimeMillisValue = endDateValue + ' ' + endTimeValue;
}

startTimeSelect(e) {
  this.startTimeSelected = true;
}

endTimeSelect(e) {
  this.endTimeSelected = true;
}

startTimeValue() {
  this.endTimeValue();
}

endTimeValue() {
  let startAmPmValue = '';
  let endAmPmValue = '';
  const d = new Date();
  const dateValue = moment(d).format('MM/DD/YYYY');
  let startValue;
  if (this.startTimeSelected) {
    startValue = new Date(this.publishOpenShift.controls.startTime.value);
  } else {
    startValue = new Date(dateValue + ' ' + this.publishOpenShift.controls.startTime.value);
  }
  let endValue;
  if (this.endTimeSelected) {
    endValue = new Date(this.publishOpenShift.controls.endTime.value);
  } else {
    endValue = new Date(dateValue + ' ' + this.publishOpenShift.controls.endTime.value);
  }

  if (this.publishOpenShift.controls.startTime.value) {
    startAmPmValue = moment(startValue).format('a');
  }

  if (this.publishOpenShift.controls.endTime.value) {
    endAmPmValue = moment(endValue).format('a');
  }

  if (startAmPmValue === 'pm' && endAmPmValue === 'am') {
    this.startEndTimeAMPMFlag = false;
  } else {
    this.startEndTimeAMPMFlag = true;
  }
  startValue.setSeconds(0, 0);
  endValue.setSeconds(0, 0);
  this.endTime = this.publishOpenShift.controls.endTime.value;

  // if ((this.Form.controls.startTime.value > this.Form.controls.endTime.value ||
  // this.Form.controls.startTime.value === this.Form.controls.endTime.value)  &&
  // !!this.Form.controls.startTime.value && !!this.Form.controls.endTime.value) {

  if ((((startValue.getTime() > endValue.getTime()) && (this.startEndTimeAMPMFlag)) || startValue.getTime() === endValue.getTime())
    && !!this.publishOpenShift.controls.startTime.value && !!this.publishOpenShift.controls.endTime.value) {
    // this.Form.controls.endTime.reset();
    this.endTimeErrorFlag = false;
    this.publishOpenShift.controls.endTime.setValue(null);
    this.uiService.showMessage('End time should be greater than Start time', AppSettings.MESSAGE_TYPES.ERROR);
  } else {
    this.endTimeErrorFlag = true;
  }
}

private applyProviderRoleScope() {
  const roleId = this.storageService.getItem<number>(AppSettings.USER_ROLE_ID);
  if (roleId === AppSettings.PROVIDER_ROLE_ID || roleId === 11) {
    this.providerId = this.loginUserId;
  }
}

getTeam() {
  // this.teamList = [];
  const providerLevelDOO = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)?.value;
  const teamLevelDOO = this.commonService.getGlobalConfigByKey(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL)?.value;
  this.teamList.push({ label: this.commonService.getLabel('Select Team'), value: '' });
  this.manageOpenShiftsService.getTeam(this.providerId).subscribe((result) => {
    if (providerLevelDOO || teamLevelDOO) {
      const restrictedTeamsList = providerLevelDOO
        ? this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.PROVIDER_LVL)
        : this.commonService.getDutyOnOffDispatchLevelArr(AppSettings.GLOBAL_CONFIGRATION.TEAM_LVL);
      restrictedTeamsList.forEach(e => {
        result = result.filter(ele => (ele.id !== e.teamId) && (ele.providerId !== e.providerId));
      });
    }
    result.forEach(ele =>
      this.teamList.push({
        label: ele.teamName, value: ele.id
      }));
    //  this.teamList.sort((a, b) => a.label.localeCompare(b.label));
  }, (error) => {
  });
}
onChangemarketTeam(event) {
  this.teamId = event.value;
  if (this.teamId) {
    this.changeTeamListDate(this.teamId);
  }
  this.publishOpenShift.controls.teamMembers.setValue([]);
}
changeTeamShiftDate(event) {
  if (this.teamId) {
    this.changeTeamListDate(this.teamId);
  }
  this.publishOpenShift.controls.teamMembers.setValue([]);
}
onMarketSelect(event) {
}

onKeypress(event) {
  console.log('111111111', event);

  if (event.which === 48) {
    return false;
  }
}
getTime(event: any) {
  if (this.publishOpenShift.controls.startTime.value !== '') {
    const hour = moment(this.publishOpenShift.controls.startTime.value).format('hh:mm A').split(':');
    const time = this.commonBindingDataService.timeAdjustment(hour);
    const dateValue = this.publishOpenShift.controls.shiftDate.value;
    const dateOnly = new Date(dateValue).toLocaleDateString();
    this.availableStartTime = new Date(`${dateOnly} ${time}`);
    // this.publishOpenShift.controls.startTime.setValue(this.availableStartTime);
  }
}

getEndTime(event: any) {
  if (this.publishOpenShift.controls.endTime.value !== '') {
    const hour1 = moment(this.publishOpenShift.controls.endTime.value).format('hh:mm A');
    const hour = moment(this.publishOpenShift.controls.endTime.value).format('hh:mm A').split(':');
    if (hour1 !== '11:59 PM') {
      const time = this.commonBindingDataService.timeAdjustment(hour);
      const dateValue = this.publishOpenShift.controls.shiftDate.value;
      const dateOnly = new Date(dateValue).toLocaleDateString();
      this.availableEndTime = new Date(`${dateOnly} ${time}`);
      // this.publishOpenShift.controls.endTime.setValue(this.availableEndTime);

    } else {
      const dateValue = this.publishOpenShift.controls.shiftDate.value;
      const dateOnly = new Date(dateValue).toLocaleDateString();
      const combinedDateTimeString = `${dateOnly} ${hour1}`;
      const availableEndTime = new Date(combinedDateTimeString);
      // this.publishOpenShift.controls.endTime.setValue(availableEndTime);
    }


    setTimeout(() => {
      this.startTimeValue();
    }, 500);
  }
}
}

